const BUSINESS_LABEL = Object.freeze({
    IS_NEW: 'new_service',
    VEGAN: 'vegan',
    VERIFIED_MIRCITY: 'verified',
    DISH_GIFT: 'dish_gift',
});

const BUSINESS_LABEL_SIDE = Object.freeze({
    TOP_RIGHT: 1,
    TOP_LEFT: 2,
    BOTTOM_RIGHT: 3,
    BOTTOM_LEFT: 4
})

module.exports = {
    BUSINESS_LABEL,
    BUSINESS_LABEL_SIDE
};